var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPuntos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.118,
    height: 73.95,
    viewBox: "0 0 114.118 73.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4189",
    "data-name": "Grupo 4189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_718",
    "data-name": "Trazado 718",
    d: "M72.123,1059.278a2.494,2.494,0,1,1-2.506,2.495,2.5,2.5,0,0,1,2.506-2.495",
    transform: "translate(-69.617 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_719",
    "data-name": "Trazado 719",
    d: "M72.123,1047.3a2.494,2.494,0,1,1-2.506,2.495,2.5,2.5,0,0,1,2.506-2.495",
    transform: "translate(-69.617 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_720",
    "data-name": "Trazado 720",
    d: "M72.123,1035.315a2.494,2.494,0,1,1-2.506,2.493,2.5,2.5,0,0,1,2.506-2.493",
    transform: "translate(-69.617 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_721",
    "data-name": "Trazado 721",
    d: "M72.123,1023.334a2.494,2.494,0,1,1-2.506,2.493,2.5,2.5,0,0,1,2.506-2.493",
    transform: "translate(-69.617 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_722",
    "data-name": "Trazado 722",
    d: "M72.123,1011.352a2.494,2.494,0,1,1-2.506,2.493,2.5,2.5,0,0,1,2.506-2.493",
    transform: "translate(-69.617 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_723",
    "data-name": "Trazado 723",
    d: "M72.123,999.371a2.493,2.493,0,1,1-2.506,2.493,2.5,2.5,0,0,1,2.506-2.493",
    transform: "translate(-69.617 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_724",
    "data-name": "Trazado 724",
    d: "M85.663,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-67.57 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_725",
    "data-name": "Trazado 725",
    d: "M85.663,1047.3a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-67.57 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_726",
    "data-name": "Trazado 726",
    d: "M85.663,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-67.57 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_727",
    "data-name": "Trazado 727",
    d: "M85.663,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-67.57 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_728",
    "data-name": "Trazado 728",
    d: "M85.663,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-67.57 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_729",
    "data-name": "Trazado 729",
    d: "M85.663,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-67.57 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_730",
    "data-name": "Trazado 730",
    d: "M99.2,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-65.524 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_731",
    "data-name": "Trazado 731",
    d: "M99.2,1047.3a2.494,2.494,0,1,1-2.507,2.495A2.5,2.5,0,0,1,99.2,1047.3",
    transform: "translate(-65.524 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_732",
    "data-name": "Trazado 732",
    d: "M99.2,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-65.524 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_733",
    "data-name": "Trazado 733",
    d: "M99.2,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-65.524 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_734",
    "data-name": "Trazado 734",
    d: "M99.2,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-65.524 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_735",
    "data-name": "Trazado 735",
    d: "M99.2,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-65.524 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_736",
    "data-name": "Trazado 736",
    d: "M112.743,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-63.477 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_737",
    "data-name": "Trazado 737",
    d: "M112.743,1047.3a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-63.477 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_738",
    "data-name": "Trazado 738",
    d: "M112.743,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-63.477 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_739",
    "data-name": "Trazado 739",
    d: "M112.743,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-63.477 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_740",
    "data-name": "Trazado 740",
    d: "M112.743,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-63.477 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_741",
    "data-name": "Trazado 741",
    d: "M112.743,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-63.477 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_742",
    "data-name": "Trazado 742",
    d: "M126.283,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-61.431 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_743",
    "data-name": "Trazado 743",
    d: "M126.283,1047.3a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-61.431 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_744",
    "data-name": "Trazado 744",
    d: "M126.283,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-61.431 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_745",
    "data-name": "Trazado 745",
    d: "M126.283,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-61.431 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_746",
    "data-name": "Trazado 746",
    d: "M126.283,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-61.431 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_747",
    "data-name": "Trazado 747",
    d: "M126.283,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-61.431 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_748",
    "data-name": "Trazado 748",
    d: "M139.823,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-59.384 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_749",
    "data-name": "Trazado 749",
    d: "M139.823,1047.3a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-59.384 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_750",
    "data-name": "Trazado 750",
    d: "M139.823,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-59.384 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_751",
    "data-name": "Trazado 751",
    d: "M139.823,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-59.384 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_752",
    "data-name": "Trazado 752",
    d: "M139.823,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-59.384 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_753",
    "data-name": "Trazado 753",
    d: "M139.823,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-59.384 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_754",
    "data-name": "Trazado 754",
    d: "M153.363,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-57.338 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_755",
    "data-name": "Trazado 755",
    d: "M153.363,1047.3a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-57.338 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_756",
    "data-name": "Trazado 756",
    d: "M153.363,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-57.338 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_757",
    "data-name": "Trazado 757",
    d: "M153.363,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-57.338 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_758",
    "data-name": "Trazado 758",
    d: "M153.363,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-57.338 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_759",
    "data-name": "Trazado 759",
    d: "M153.363,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-57.338 -999.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_760",
    "data-name": "Trazado 760",
    d: "M166.9,1059.278a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-55.291 -990.316)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_761",
    "data-name": "Trazado 761",
    d: "M166.9,1047.3a2.494,2.494,0,1,1-2.507,2.495,2.5,2.5,0,0,1,2.507-2.495",
    transform: "translate(-55.291 -992.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_762",
    "data-name": "Trazado 762",
    d: "M166.9,1035.315a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-55.291 -993.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_763",
    "data-name": "Trazado 763",
    d: "M166.9,1023.334a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-55.291 -995.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_764",
    "data-name": "Trazado 764",
    d: "M166.9,1011.352a2.494,2.494,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-55.291 -997.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_765",
    "data-name": "Trazado 765",
    d: "M166.9,999.371a2.493,2.493,0,1,1-2.507,2.493,2.5,2.5,0,0,1,2.507-2.493",
    transform: "translate(-55.291 -999.371)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuntos);
export default __webpack_public_path__ + "static/media/puntos.8ae56eeef3d42c2ef6823edba2607c6c.svg";
export { ForwardRef as ReactComponent };